import { create } from "zustand";
import { devtools } from "zustand/middleware";

import { ENABLE_REDUX_DEVTOOLS } from "stores/constants";
import { Site } from "interfaces/kpis";

export interface State {
  selectedYear: number | undefined;
  setSelectedYear: (year: number) => void;

  selectedSite: Site | undefined;
  setSelectedSite: (site: Site) => void;

  selectedMachines: number[];
  addSelectedMachines: (machinesIdsToAdd: number[]) => void;
  removeSelectedMachines: (machinesIdsToRemove: number[]) => void;
  isSelectedMachine: (machineId: number) => boolean;
  resetSelectedMachines: () => void;
}

export const useKpisStore = create<State>()(
  devtools(
    (set, get) => ({
      selectedYear: undefined,
      setSelectedYear: year =>
        set({ selectedYear: year }, false, "KPIS_STORE/setSelectedYear"),

      selectedSite: undefined,
      setSelectedSite: site =>
        set({ selectedSite: site }, false, "KPIS_STORE/setSelectedSite"),

      selectedMachines: [],
      addSelectedMachines: machineIdsToAdd => {
        set(
          {
            selectedMachines: [...get().selectedMachines, ...machineIdsToAdd]
          },
          false,
          "KPIS_STORE/addSelectedMachines"
        );
      },
      removeSelectedMachines: machineIdsToRemove => {
        set(
          {
            selectedMachines: get().selectedMachines.filter(
              machineId => !machineIdsToRemove.includes(machineId)
            )
          },
          false,
          "KPIS_STORE/removeSelectedMachines"
        );
      },
      isSelectedMachine: machineId => {
        return get().selectedMachines.includes(machineId);
      },
      resetSelectedMachines: () =>
        set({ selectedMachines: [] }, false, "KPIS_STORE/resetSelectedMachines")
    }),
    { enabled: ENABLE_REDUX_DEVTOOLS, store: "KpisStore" }
  )
);
